import { render, staticRenderFns } from "./formData.vue?vue&type=template&id=6ce329ab&scoped=true"
import script from "./formData.vue?vue&type=script&lang=js"
export * from "./formData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce329ab",
  null
  
)

export default component.exports